import React from 'react';
import { useDispatch } from 'react-redux';
import useUserLogged from 'src/hooks/useUserLogged';
import { useMetadataMutation } from 'src/redux/api/auth';
import { metadataCompleted } from 'src/redux/slices/auth';
import useError, { reportError } from 'src/screens/error/useError';
import CustomSelect from 'src/screens/shared/components/CustomSelect/CustomSelect';

type Props = {
  onSubmit: () => void;
};

const AccountSelector = ({ onSubmit }: Props) => {
  const { currentUser, currentAccount, isSuperAdminOnlyLogged } = useUserLogged();
  const [metadata] = useMetadataMutation();
  const dispatch = useDispatch();
  const { setError } = useError();

  if (!currentAccount || isSuperAdminOnlyLogged) return null;

  const handleItemSelected = (id: number) => {
    metadata(id)
      .unwrap()
      .then((response) => {
        dispatch(metadataCompleted(response.data));
        onSubmit();
      })
      .catch((e) => {
        setError(reportError(e));
      });
  };

  return currentAccount?.name ? (
    <>
      <CustomSelect
        defaultValue={currentAccount.name}
        style={{ width: 160 }}
        onChange={(accountId) => {
          handleItemSelected(parseInt(accountId, 10));
        }}
        options={currentUser?.accounts.data.map((account) => ({
          value: account.id,
          label: account.name,
        }))}
        popupClassName="account-selector-options"
      />
    </>
  ) : null;
};

export default AccountSelector;
